import { BaseQueryFn } from "@reduxjs/toolkit/query";
import { AxiosRequestConfig } from "axios";
import { apiDelete, apiGet, apiPatch, apiPost, apiPut } from "./apiUtils";

const axiosBaseQuery =
  (): BaseQueryFn<
    {
      url: string;
      method: "get" | "post" | "put" | "patch" | "delete";
      data?: any;
      params?: any;
      headers?: Record<string, string>;
      requestOptions?: AxiosRequestConfig;
      state?: any;
    },
    unknown,
    unknown
  > =>
  async ({ url, method, data, params, headers, requestOptions }, api) => {
    try {
      let result;

      const state = api.getState();

      console.log(
        "url",
        url,
        "data",
        data,
        "params",
        params,
        "state",
        state,
        "headers",
        headers,
        "requestOptions",
        requestOptions,
      );

      switch (method) {
        case "get":
          result = await apiGet(
            url,
            params ?? data,
            state,
            headers,
            requestOptions,
          );
          break;

        case "post":
          result = await apiPost(url, data, state, headers);
          break;

        case "put":
          result = await apiPut(url, data, state, headers);
          break;

        case "patch":
          result = await apiPatch(url, data, state, headers);
          break;

        case "delete":
          result = await apiDelete(url, data, state, headers);
          break;

        default:
          throw new Error(`Unsupported method: ${method}`);
      }

      console.log("API Result:", result.data);

      return {
        data: result.data,
      };
    } catch (error: any) {
      console.error("apiBaseQuery Intercept Error Node:", error);

      return {
        error: {
          status: error?.status || 500,

          data:
            error?.data ||
            error ||
            "An unexpected error occurred during bulk processing.",
        },
      };
    }
  };

export default axiosBaseQuery;
